import { Stack } from "@mui/material";
import { CopyableTextField } from "@src/appV2/CopyableTextField/CopyableTextField";

import { NavigationMenuSectionTitleDesktop } from "./MenuSectionTitle";

interface CurrentlyViewedSectionDesktopProps {
  admin: boolean;
  isWorker: boolean;
  isWorkplace: boolean;
  currentName: string;
  currentUserId: string;
}

export function CurrentlyViewedSectionDesktop(props: CurrentlyViewedSectionDesktopProps) {
  const { admin, isWorker, isWorkplace, currentName, currentUserId } = props;

  // Only show for admin users, that are currently posing as workplace or worker
  if (!admin || (!isWorker && !isWorkplace)) {
    return null;
  }

  return (
    <>
      <NavigationMenuSectionTitleDesktop>Currently Viewed</NavigationMenuSectionTitleDesktop>
      <Stack gap={2}>
        <CopyableTextField
          label={isWorkplace ? "Workplace Name" : "Professional Name"}
          value={currentName}
        />
        <CopyableTextField
          label={isWorkplace ? "Workplace ID" : "Professional ID"}
          value={currentUserId}
        />
      </Stack>
    </>
  );
}
